import { render, staticRenderFns } from "./OtpField.vue?vue&type=template&id=29b9a016&scoped=true&lang=pug&"
import script from "./OtpField.vue?vue&type=script&lang=js&"
export * from "./OtpField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b9a016",
  null
  
)

export default component.exports